import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.2rem;
	border-radius: 5px;
	background-color: ${color.interface.lightGray4};

	> p {
		text-align: center;
		font-size: 1.35rem;
		color: ${color.interface.darkgray3};
	}

	> svg {
		font-size: 4rem;
		color: ${color.interface.darkgray3};
	}
`;
